module.exports = __webpack_public_path__ + "img/cat2.6866972e.svg";